var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('li',[_vm._v(_vm._s(_vm._f("translate")('DOWNLOAD_PDF_1')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm._f("translate")('DOWNLOAD_PDF_2')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm._f("translate")('DOWNLOAD_PDF_3')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1715126e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/mockups/MockTabDocuments.vue
// module id = null
// module chunks = 